const awardGrid = document.querySelector("#awards-tiles-grid");
const pickerAwardYear = document.querySelector("#picker-award-year");

if (
  awardGrid instanceof HTMLElement &&
  pickerAwardYear instanceof HTMLSelectElement
) {
  pickerAwardYear.addEventListener("change", function () {
    let selectedYear = "year-" + pickerAwardYear.value;

    if (selectedYear === "year-") {
      document.querySelectorAll(".grid-item").forEach(function (el) {
        el.style.display = "block";
      });
    } else {
      document.querySelectorAll(".grid-item").forEach(function (el) {
        el.style.display = "none";
      });
      document.querySelectorAll("." + selectedYear).forEach(function (el) {
        el.style.display = "block";
      });
    }
  });
}
